import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import FreeSoloCreateOption from './createable-autocomplete';

export default function AddDialog(props) {
    const { onSave, onClose, open } = props;

    const [orderNo, setOrderNo] = React.useState("");
    const [farmName, setFarmName] = React.useState("");
    const [locationName, setLocationName] = React.useState("");
    const [locationLat, setLocationLat] = React.useState("");
    const [locationLng, setLocationLng] = React.useState("");
    const [quantity, setQuantity] = React.useState("");
    const [pickupDate, setPickupDate] = React.useState(dayjs(new Date()));

    const handleClose = () => {
        onClose();
    };

    const handleSave = () => {
        onSave({
            order_no: orderNo,
            farm_name: farmName,
            location: {
                name: locationName,
                lat: parseFloat(locationLat),
                lng: parseFloat(locationLng)
            },
            quantity: parseInt(quantity),
            pickup_date: new Date(pickupDate).toISOString(),
            status: "open"
        });
    };

    const setFarmValues = (data) => {
        if (data) {
            setFarmName(data.farm_name);
            setLocationName(data.location.name);
            setLocationLat(data.location.lat);
            setLocationLng(data.location.lng);
        } else {
            setFarmName("");
            setLocationName("");
            setLocationLat("");
            setLocationLng("");
        }

    }

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>{`Add new order`}</DialogTitle>
            <Box
                // component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
                style={{ padding: '0 24px' }}
            >
                <div>
                    <div>
                        <TextField
                            id="order-no"
                            label="Order No."
                            value={orderNo}
                            onChange={(e) => setOrderNo(e.target.value)}
                        />
                        <FreeSoloCreateOption
                            id="farm-name"
                            label="Farm Name"
                            value={farmName}
                            setValue={(e) => setFarmValues(e)} />
                        {/* <TextField
                            id="farm-name"
                            label="Farm Name"
                            value={farmName}
                            onChange={(e) => setFarmName(e.target.value)}
                        /> */}
                    </div>
                    {farmName && <>
                        <Divider style={{ margin: '10px 0' }}>
                            <Chip label="Location Info" size="small" />
                        </Divider>
                        <TextField
                            id="location-name"
                            label="Location Name"
                            value={locationName}
                            onChange={(e) => setLocationName(e.target.value)}
                        />

                        <TextField
                            id="location-lat"
                            label="Location Latitude"
                            value={locationLat}
                            onChange={(e) => setLocationLat(e.target.value)}
                        />
                        <TextField
                            id="location-lng"
                            label="Location Longitude"
                            value={locationLng}
                            onChange={(e) => setLocationLng(e.target.value)}
                        />
                        <Divider style={{ margin: '10px 0' }} />
                    </>}
                    <div>
                        <TextField
                            id="quantity"
                            label="Quantity"
                            type='number'
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                        />
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                label="PickUp Date"
                                value={pickupDate}
                                onChange={(e) => setPickupDate(e)}
                                slotProps={{ popper: { placement: 'right-start' } }} />
                        </LocalizationProvider>
                    </div>
                    <div style={{ margin: '10px', float: 'right' }}>
                        <button className="btn btn-primary success" style={{ marginRight: '10px' }} onClick={handleSave}>Save</button>
                        <button className="btn btn-primary success" onClick={() => handleClose()}>Cancel</button>
                    </div>
                </div>
            </Box>
        </Dialog>
    );
}
